/**
 * @flow
 * @relayHash fe321d935ec007ed385f15e3f8a6c5f6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MpTemplateContainer_node$ref = any;
export type UpdateMpTemplatePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  description?: ?string,
  position?: ?number,
  max_length?: ?number,
};
export type MpTemplateComponent_UpdateMpTemplatePlaylistMutationVariables = {|
  input: UpdateMpTemplatePlaylistInput
|};
export type MpTemplateComponent_UpdateMpTemplatePlaylistMutationResponse = {|
  +updateMpTemplatePlaylist: ?{|
    +mp_template: ?{|
      +$fragmentRefs: MpTemplateContainer_node$ref
    |}
  |}
|};
export type MpTemplateComponent_UpdateMpTemplatePlaylistMutation = {|
  variables: MpTemplateComponent_UpdateMpTemplatePlaylistMutationVariables,
  response: MpTemplateComponent_UpdateMpTemplatePlaylistMutationResponse,
|};
*/


/*
mutation MpTemplateComponent_UpdateMpTemplatePlaylistMutation(
  $input: UpdateMpTemplatePlaylistInput!
) {
  updateMpTemplatePlaylist(input: $input) {
    mp_template {
      ...MpTemplateContainer_node
      id
    }
  }
}

fragment MpTemplateContainer_node on MpTemplate {
  id
  title
  description
  notes
  can_edit
  public
  brand {
    id
    logo_url
    header
  }
  mp_template_playlists(first: 99999) {
    edges {
      node {
        id
        title
        description
        thumbnail(width: 240, height: 240) {
          url
          width
          height
          id
        }
        num_songs
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateMpTemplatePlaylistInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateMpTemplatePlaylistInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "MpTemplateComponent_UpdateMpTemplatePlaylistMutation",
  "id": null,
  "text": "mutation MpTemplateComponent_UpdateMpTemplatePlaylistMutation(\n  $input: UpdateMpTemplatePlaylistInput!\n) {\n  updateMpTemplatePlaylist(input: $input) {\n    mp_template {\n      ...MpTemplateContainer_node\n      id\n    }\n  }\n}\n\nfragment MpTemplateContainer_node on MpTemplate {\n  id\n  title\n  description\n  notes\n  can_edit\n  public\n  brand {\n    id\n    logo_url\n    header\n  }\n  mp_template_playlists(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        description\n        thumbnail(width: 240, height: 240) {\n          url\n          width\n          height\n          id\n        }\n        num_songs\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MpTemplateComponent_UpdateMpTemplatePlaylistMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMpTemplatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMpTemplatePlaylistPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplate",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "MpTemplateContainer_node",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MpTemplateComponent_UpdateMpTemplatePlaylistMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateMpTemplatePlaylist",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateMpTemplatePlaylistPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "mp_template",
            "storageKey": null,
            "args": null,
            "concreteType": "MpTemplate",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "public",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "brand",
                "storageKey": null,
                "args": null,
                "concreteType": "Brand",
                "plural": false,
                "selections": [
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "logo_url",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "header",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mp_template_playlists",
                "storageKey": "mp_template_playlists(first:99999)",
                "args": v5,
                "concreteType": "MpTemplatePlaylistConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MpTemplatePlaylistEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MpTemplatePlaylist",
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          v4,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "thumbnail",
                            "storageKey": "thumbnail(height:240,width:240)",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "height",
                                "value": 240,
                                "type": "Int"
                              },
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 240,
                                "type": "Int"
                              }
                            ],
                            "concreteType": "SongImage",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "url",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "width",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "height",
                                "args": null,
                                "storageKey": null
                              },
                              v2
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "num_songs",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__typename",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "mp_template_playlists",
                "args": v5,
                "handle": "connection",
                "key": "MpTemplateContainer_mp_template_playlists",
                "filters": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a08a93aa425086134895f1b7b4137aeb';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/MusicPlanner/__generated__/MpTemplateComponent_UpdateMpTemplatePlaylistMutation.graphql.js